import React, { Component } from "react";
import NavLink from "./NavLink/NavLink";
import "./Nav.css";

class Nav extends Component {
	// Renders nav links according to current product lineup
	render() {
		return (
			<div className="nav">
				<div className="nav-left">
					<img
						src={this.props.logo}
						alt="FMeasure"
						onClick={() => this.props.changeLocation(this.props.user === true ? "/dashboard" : "https://www.fmeasure.com")}
					/>
					{this.props.user === true && (<NavLink
					prod={'search'}
					changeLocation={this.props.changeLocation}
				/>)}
				</div>
				{this.props.user === true && (
					<button
						id="account-button"
						onClick={() => this.props.changeLocation("/dashboard/account")}
					>
						Account
					</button>
				)}
			</div>
		);
	}
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js